import { Button } from "reactstrap"
import ThumbnailImage from "components/Common/ThumbnailImage"
import StatusBadge from "components/Common/StatusBadge"
import LiveIndicator from "components/Common/LiveIndicator/LiveIndicator"
import ViewOnWebsite from "pages/StockPages/StockView/ViewOnWebsite"
import StockImagesUpdate from "pages/StockPages/StockView/StockImagesUpdate"

const StockIdCell = ({ stock, openImageViewer, setImageTitle }) => {
  const stockImageUrls = Array.isArray(stock?.images)
    ? stock.images
        .map(image => (typeof image === "string" ? image : image?.url))
        .filter(Boolean)
    : []

  return (
    <div
      className="text-wrap"
      style={{
        minWidth: "5rem",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      }}
    >
      {stock.stock_id}

      <div className="text-muted d-block mt-1">
        {stock.full_chassis ?? "-"}
      </div>

      <ThumbnailImage
        primaryImage={stock?.primary_image}
        images={stock?.images}
        alt="No Image"
      />
      <div className="mt-1">
        <StockImagesUpdate
          stock={stock}
          btnId={`stock-list-edit-images-${stock.id || stock.stock_id}`}
          isLabel={true}
        />
      </div>

      <div className="text-muted d-block mt-1">
        <StatusBadge
          trueLabel="Published"
          falseLabel="Draft"
          trueColor="primary"
          falseColor="warning"
          value={stock.is_published}
        />
      </div>

      {stock.is_published_on_website && (
        <LiveIndicator text="Live on Website" />
      )}

      <ViewOnWebsite stock_id={stock.stock_id} />

      {stockImageUrls.length > 0 && (
        <div className="mt-1">
          <Button
            size="sm"
            color="info"
            onClick={() => {
              openImageViewer(stockImageUrls)
              setImageTitle(`Stock Images - ${stock.full_chassis}`)
            }}
          >
            View Images
          </Button>
        </div>
      )}

      {stock?.auction_sheet?.url && (
        <div className="mt-1">
          <Button
            size="sm"
            color="success"
            onClick={() => {
              openImageViewer(stock.auction_sheet.url)
              setImageTitle(`Auction Sheet - ${stock.full_chassis}`)
            }}
          >
            View Auction Sheet
          </Button>
        </div>
      )}
    </div>
  )
}

export default StockIdCell
